export default __webpack_public_path__ + "static/media/stx.bd4e17fb.png";